import { ActiveAccountCard } from "@/components/account-center/TopBarAccountCluster";
import { PlanIndicator } from "@/components/account-center/PlanIndicator";
import { GlobalClock } from "@/components/GlobalClock";
import { UserMenu } from "@/components/UserMenu";
import { TourGuideButton } from "@/components/tour-guide";
import { useUserRole } from "@/hooks/useUserRole";
import jourexLogo from "@/assets/jourex-logo.png";

interface TopBarProps {
  isRTL: boolean;
}

export const TopBar = ({ isRTL }: TopBarProps) => {
  const { role } = useUserRole();
  const isIB = role === "ib";
  const isTrader = role === "trader";

  return (
    <header
      className="hidden lg:flex fixed top-0 left-0 right-0 z-50 h-24 items-center justify-between border-b bg-card/95 backdrop-blur-sm px-6 shadow-sm"
    >
      <div className="flex items-center">
        <img
          src={jourexLogo}
          alt="JouRex"
          className="h-16 w-auto select-none"
          draggable={false}
        />
      </div>
      <div className="flex items-center gap-2">
        {isTrader && <TourGuideButton />}
        {!isIB && <PlanIndicator />}
        {!isIB && <ActiveAccountCard />}
        <GlobalClock />
        <UserMenu />
      </div>
    </header>
  );
};
